import React from 'react';
import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonModal,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import useIonicModalProps from '../../../hooks/useIonicModalProps';
import styled from 'styled-components';
import { child } from 'firebase/database';
import { arrowBackOutline } from 'ionicons/icons';

interface ProfileModalProps {
  title: string | React.ReactNode;
  trigger?: string;
  isOpen?: boolean;
  children: ((props: ChildProps) => React.ReactNode) | React.ReactNode;
  onClose?: () => void;
  onBack?: () => void;
}

interface ChildProps {
  close: () => void;
}

const Content = styled.div`
  padding: 0 42px;
  margin-top: 42px;

  @media (max-width: 480px) {
    padding: 0;
  }
`;

const ProfileModal: React.FC<ProfileModalProps> = ({
  title,
  trigger,
  children,
  onClose,
  onBack,
  isOpen,
}) => {
  const modalProps = useIonicModalProps();
  return (
    <IonModal
      trigger={trigger}
      isOpen={isOpen}
      {...modalProps}
      onDidDismiss={onClose}
    >
      <IonHeader>
        <IonToolbar>
          {onBack && (
            <IonButtons slot="start">
              <IonButton onClick={onBack}>
                <IonIcon icon={arrowBackOutline} />
              </IonButton>
            </IonButtons>
          )}
          <IonTitle>{title}</IonTitle>
          <IonButtons slot="end">
            <IonButton title="Close" onClick={modalProps.onClose}>
              Close
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <Content>
          {typeof children === 'function'
            ? children({ close: modalProps.onClose })
            : children}
        </Content>
      </IonContent>
    </IonModal>
  );
};

export default ProfileModal;
